import { PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { TOtpStore, TVerificationResponse } from '~/store/otp-verification/types.ts';

export const personalDataVerificationFulfilled = (
  state: TOtpStore,
  action: PayloadAction<TVerificationResponse>
) => {
  state.isVerified = action.payload.isVerified;
  state.phone = action.payload.phone;

  state.loading = false;
  state.error = null;
  state.status = '';
};

export const personalDataVerificationPending = (state: TOtpStore) => {
  state.loading = true;
  state.isVerified = false;
  state.phone = '';
};
